import { Select, MenuItem, TextField, Grid, IconButton, Icon, Checkbox, InputAdornment, Box } from '@mui/material';
import { memo, useState } from 'react';
import MyIcon from '../../shared/util/sweetalert/myIcon';
import JojoDialog from '../conditionDialog/jojo/jojoDialog';
import { ItemLabelBox, ItemLabelTypography } from './conditionalParts.style';
import { conditionItemList, dialogItems, rangeDialogItems } from './const';
import SwalUtil from '../../shared/util/sweetalert/sweetalertUtil';
import { ReactComponent as DialogIcon } from './dialogIcon.svg';
import EtoDialog from '../conditionDialog/eto/etoDialog';
import ShusshinkoDialog from '../conditionDialog/shusshinko/shusshinkoDialog';
import ShusshinchiDialog from '../conditionDialog/shusshinchi/shusshinchiDialog';
import SetsuritsuDialog from '../conditionDialog/setsuritsu/setsuritsuDialog';
import TorihikiginkoDialog from '../conditionDialog/torihikiginko/torihikiginkoDialog';
import SogyoDialog from '../conditionDialog/sogyo/sogyoDialog';
import ShihonkinDialog from '../conditionDialog/shihonkin/shihonkinDialog';
import JugyoinsuDialog from '../conditionDialog/jugyoinsu/jugyoinsuDialog';
import { sessionDisconnectedCheck } from '../../shared/api/sessionDisconnectedCheck';
import { useNavigate } from 'react-router-dom';
import KessangetsuDialog from '../conditionDialog/kessangetsu/kessangetsuDialog';
import SaishinuriageDialog from '../conditionDialog/saishinuriage/saishinuriageDialog';
import SaishinriekiDialog from '../conditionDialog/saishinrieki/saishinriekiDialog';
import UriageshinchoritsuDialog from '../conditionDialog/uriageshinchoritsu/uriageshinchoritsuDialog';
import RiekishinchoritsuDialog from '../conditionDialog/riekishinchoritsu/riekishinchoritsuDialog';
import ShozaichiDialog from '../conditionDialog/shozaichi/shozaichiDialog';
import SeinengappiDialog from '../conditionDialog/seinengappi/seinengappiDialog';
import GyoshuDialog from '../conditionDialog/gyoshu/gyoshuDialog';

interface AddDialogItem {
    id: string[] | string
    value: string
}

interface RangeDialogItem {
    from: string
    to: string
}
interface SearchItem {
    itemCode: string;
    operator: string;
    inputValue: string;
    inputLabel?: string;
    matchFlag?: boolean;
}

interface HandleFunction {
    chengeOperatorFunction: (selectVal: 'AND' | 'OR') => void
    chengeValFunction: (inputVal: string, inputLabel?: string) => void
    chengeMatchCheckboxFunction?: (isChecked: boolean) => void
    clearValFunction?: () => void
}

interface ConditionParts {
    searchItem: SearchItem
    handlFunction: HandleFunction
}

interface DialogOpenControl {
    [conditionItemCode: string]: (openFlag: boolean) => void;
}

const screenId = "U040"

const ConditionalParts = memo((props: ConditionParts) => {
    const navigate = useNavigate();
    const { searchItem, handlFunction } = props;
    const { itemCode, operator, inputValue, inputLabel = '', matchFlag } = searchItem;
    const { chengeOperatorFunction, chengeValFunction, chengeMatchCheckboxFunction = () => { }, clearValFunction = () => { } } = handlFunction;
    const { itemName, placeholder, dialogFlag, matchCheckboxFlag, valueAssociatedWithCodeFlag } = conditionItemList[itemCode];

    // 各ダイアログ表示管理
    const [jojoDialogOpen, setJojoDialogOpen] = useState(false);
    const [shozaichiDialogOpen, setShozaichiDialogOpen] = useState(false);
    const [setsuritsuDialogOpen, setSetsuritsuDialogOpen] = useState(false);
    const [sogyoDialogOpen, setSogyoDialogOpen] = useState(false);
    const [shihonkinDialogOpen, setShihonkinDialogOpen] = useState(false);
    const [jugyoinsuDialogOpen, setJugyoinsuDialogOpen] = useState(false);
    const [gyoshuDialogOpen, setGyoshuDialogOpen] = useState(false);
    const [torihikiginkoDialogOpen, setTorihikiginkoDialogOpen] = useState(false);
    const [kessangetsuDialogOpen, setKessangetsuDialogOpen] = useState(false);
    const [saishinuriageDialogOpen, setSaishinuriageDialogOpen] = useState(false);
    const [saishinriekiDialogOpen, setSaishinriekiDialogOpen] = useState(false);
    const [uriageshinchoritsuDialogOpen, setUriageshinchoritsuDialogOpen] = useState(false);
    const [riekishinchoritsuDialogOpen, setRiekishinchoritsuDialogOpen] = useState(false);
    const [seinengappiDialogOpen, setSeinengappiDialogOpen] = useState(false);
    const [etoDialogOpen, setEtoDialogOpen] = useState(false);
    const [shusshinkoDialogOpen, setShusshinkoDialogOpen] = useState(false);
    const [shusshinchiDialogOpen, setShusshinchiDialogOpen] = useState(false);
    const controlDialogOpening: DialogOpenControl = {
        jojo: (openFlag) => { setJojoDialogOpen(openFlag); },
        shozaichi: (openFlag) => { setShozaichiDialogOpen(openFlag); },
        setsuritsu: (openFlag) => { setSetsuritsuDialogOpen(openFlag); },
        sogyo: (openFlag) => { setSogyoDialogOpen(openFlag); },
        shihonkin: (openFlag) => { setShihonkinDialogOpen(openFlag); },
        jugyoinsu: (openFlag) => { setJugyoinsuDialogOpen(openFlag); },
        gyoshu: (openFlag) => { setGyoshuDialogOpen(openFlag); },
        torihikiginko: (openFlag) => { setTorihikiginkoDialogOpen(openFlag); },
        kessangetsu: (openFlag) => { setKessangetsuDialogOpen(openFlag); },
        saishinuriage: (openFlag) => { setSaishinuriageDialogOpen(openFlag); },
        saishinrieki: (openFlag) => { setSaishinriekiDialogOpen(openFlag); },
        uriageshinchoritsu: (openFlag) => { setUriageshinchoritsuDialogOpen(openFlag); },
        riekishinchoritsu: (openFlag) => { setRiekishinchoritsuDialogOpen(openFlag); },
        seinengappi: (openFlag) => { setSeinengappiDialogOpen(openFlag); },
        eto: (openFlag) => { setEtoDialogOpen(openFlag); },
        shusshinko: (openFlag) => { setShusshinkoDialogOpen(openFlag); },
        shusshinchi: (openFlag) => { setShusshinchiDialogOpen(openFlag); },
    }

    const onClickDialog = async (itemCode: string) => {
        // セッションの有効性確認
        if (await sessionDisconnectedCheck(screenId, dialogItems[itemCode], navigate)) {
            return
        }
        controlDialogOpening[itemCode](true);
    }

    // 上場、干支、出身校、出身地、取引銀行、所在地、業種ダイアログからの入力
    const handleOkAddCondition = (items: AddDialogItem[], operator: string) => {
        let conditionalVal = '';
        let conditionalLabel = '';
        for (let item of items) {
            if (Array.isArray(item.id)) {
                conditionalVal = conditionalVal !== '' ? conditionalVal + ' ' + operator + ' ' + item.id.join(' or ') : item.id.join(' or ');
            } else {
                conditionalVal = conditionalVal !== '' ? conditionalVal + ' ' + operator + ' ' + item.id : item.id;
            }
            conditionalLabel = conditionalLabel !== '' ? conditionalLabel + ' ' + operator + ' ' + item.value : item.value;
        }
        const newInputConditionalVal = inputValue !== '' ? inputValue + ' ' + operator + ' ' + conditionalVal : conditionalVal;
        const newInputConditionalLabel = inputLabel !== '' ? inputLabel + ' ' + operator + ' ' + conditionalLabel : conditionalLabel;
        const valueParts: string[] = newInputConditionalVal.split(' ');
        if (valueParts.includes('and') && valueParts.includes('or')) {
            SwalUtil.labelInfo({
                title: "演算子混在",
                message: '演算子「and」と「or」を混在させることはできません。',
                textAlign: "center",
                confirmButtonText: "OK",
                buttonAlign: "right",
                icon: 'error',
                buttonOrder: { confirm: 2, deny: 1 }
            });
        } else {
            chengeValFunction(newInputConditionalVal, newInputConditionalLabel);
            controlDialogOpening[itemCode](false);
        }
    }

    // 設立年月、創業年月、資本金、従業員数、決算月、最新売上、最新利益、売上伸長率、利益伸長率、生年月日ダイアログからの入力
    const handleOkUpdateCondition = (directItem: string, rangeItems: RangeDialogItem) => {
        let newInputConditionalVal = '';
        let newInputConditionalLabel = '';
        if (directItem !== '') {
            newInputConditionalVal = directItem + ' ' + 'to' + ' ' + directItem;
            newInputConditionalLabel = directItem + ' ' + 'to' + ' ' + directItem;
        } else {
            if (rangeItems.from === '') {
                newInputConditionalVal = rangeItems.to;
                newInputConditionalLabel = 'to' + ' ' + rangeItems.to;
            } else if (rangeItems.to === '') {
                newInputConditionalVal = rangeItems.from;
                newInputConditionalLabel = rangeItems.from + ' ' + 'to';
            } else {
                newInputConditionalVal = rangeItems.from + ' ' + 'to' + ' ' + rangeItems.to;
                newInputConditionalLabel = rangeItems.from + ' ' + 'to' + ' ' + rangeItems.to;
            }
        }
        chengeValFunction(newInputConditionalVal, newInputConditionalLabel);
        controlDialogOpening[itemCode](false);
    }

    return (
        <>
            <Box p={0.8}>
                <Grid container={true} maxHeight='40px' alignItems='center' sx={{ width: '100%' }}>
                    <Grid size={1.8}>
                        <ItemLabelBox marginLeft='10px'>
                            <ItemLabelTypography marginLeft='10px'>{itemName}</ItemLabelTypography>
                        </ItemLabelBox>
                    </Grid>
                    <Grid size={9.2}>
                        <TextField
                            onChange={(event) => chengeValFunction(event.target.value)}
                            value={rangeDialogItems.includes(itemCode) ? inputLabel : inputValue}
                            multiline={false}
                            placeholder={placeholder}
                            sx={{
                                width: '100%',
                                marginLeft: '15px',
                                '& .MuiInputBase-root': { height: '40px' },
                                '& .MuiOutlinedInput-notchedOutline': { borderRadius: '0px' },
                            }}
                            InputProps={
                                {
                                    readOnly: dialogFlag,
                                    endAdornment:
                                        <InputAdornment position='end'>
                                            {dialogFlag && inputValue !== '' && <IconButton onClick={() => clearValFunction()}>×</IconButton>}
                                        </InputAdornment>
                                }
                            }
                        />
                    </Grid>
                    <Grid size={1}>
                        {dialogFlag && <IconButton onClick={() => onClickDialog(itemCode)} sx={{ marginLeft: '10px' }}><DialogIcon /></IconButton>}
                        {matchCheckboxFlag && <Checkbox color='default' checked={matchFlag} size='medium' sx={{ marginLeft: '10px' }} onChange={(event) => chengeMatchCheckboxFunction(event.target.checked)} />}
                    </Grid>
                </Grid>
            </Box>
            {valueAssociatedWithCodeFlag &&
                <Box p={0.8}>
                    <Grid container={true} maxHeight='40px' alignItems='center' sx={{ width: '100%' }}>
                        <Grid size={12}>
                            <TextField
                                value={inputLabel}
                                multiline={false}
                                sx={{
                                    backgroundColor: '#d8d4d4ff',
                                    width: '100%',
                                    marginLeft: '10px',
                                    '& .MuiInputLabel-root': { height: '40px' },
                                    '& .MuiInputBase-root': { height: '40px' },
                                    '& .MuiOutlinedInput-notchedOutline': { borderRadius: '0px' },
                                }}
                                InputProps={
                                    {
                                        readOnly: true,
                                    }
                                }
                            />
                        </Grid>
                    </Grid>
                </Box>
            }
            <JojoDialog isOpen={jojoDialogOpen} handleOk={handleOkAddCondition} handleClose={() => controlDialogOpening[itemCode](false)} />
            <TorihikiginkoDialog isOpen={torihikiginkoDialogOpen} handleOk={handleOkAddCondition} handleClose={() => controlDialogOpening[itemCode](false)} />
            <EtoDialog isOpen={etoDialogOpen} handleOk={handleOkAddCondition} handleClose={() => controlDialogOpening[itemCode](false)} />
            <ShusshinkoDialog isOpen={shusshinkoDialogOpen} handleOk={handleOkAddCondition} handleClose={() => controlDialogOpening[itemCode](false)} />
            <ShusshinchiDialog isOpen={shusshinchiDialogOpen} handleOk={handleOkAddCondition} handleClose={() => controlDialogOpening[itemCode](false)} />
            <SetsuritsuDialog isOpen={setsuritsuDialogOpen} handleOk={handleOkUpdateCondition} handleClose={() => controlDialogOpening[itemCode](false)} />
            <SogyoDialog isOpen={sogyoDialogOpen} handleOk={handleOkUpdateCondition} handleClose={() => controlDialogOpening[itemCode](false)} />
            <ShihonkinDialog isOpen={shihonkinDialogOpen} handleOk={handleOkUpdateCondition} handleClose={() => controlDialogOpening[itemCode](false)} />
            <JugyoinsuDialog isOpen={jugyoinsuDialogOpen} handleOk={handleOkUpdateCondition} handleClose={() => controlDialogOpening[itemCode](false)} />
            <KessangetsuDialog isOpen={kessangetsuDialogOpen} handleOk={handleOkUpdateCondition} handleClose={() => controlDialogOpening[itemCode](false)} />
            <SaishinuriageDialog isOpen={saishinuriageDialogOpen} handleOk={handleOkUpdateCondition} handleClose={() => controlDialogOpening[itemCode](false)} />
            <SaishinriekiDialog isOpen={saishinriekiDialogOpen} handleOk={handleOkUpdateCondition} handleClose={() => controlDialogOpening[itemCode](false)} />
            <UriageshinchoritsuDialog isOpen={uriageshinchoritsuDialogOpen} handleOk={handleOkUpdateCondition} handleClose={() => controlDialogOpening[itemCode](false)} />
            <RiekishinchoritsuDialog isOpen={riekishinchoritsuDialogOpen} handleOk={handleOkUpdateCondition} handleClose={() => controlDialogOpening[itemCode](false)} />
            <ShozaichiDialog isOpen={shozaichiDialogOpen} handleOk={handleOkAddCondition} handleClose={() => controlDialogOpening[itemCode](false)} />
            <SeinengappiDialog isOpen={seinengappiDialogOpen} handleOk={handleOkUpdateCondition} handleClose={() => controlDialogOpening[itemCode](false)} />
            <GyoshuDialog isOpen={gyoshuDialogOpen} handleOk={handleOkAddCondition} handleClose={() => controlDialogOpening[itemCode](false)} />
        </>
    );
});
export default ConditionalParts;
